module.exports = __webpack_public_path__ + "img/banner2_7.cc63a8fe.png";